import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import store from './store/store';

//Libs
import axios from './libs/axios';
import './libs/vue-moment';
import './libs/inline-svg';
import './libs/vue-js-modal';
import './libs/moment';
import './libs/v-mask';
import './libs/vue-select';

import Notifications from 'vue-notification'
Vue.use(Notifications);

//CSS Styles
import './assets/styles/tailwind.css';

//Plugins
import './plugins';

Vue.prototype.$http = axios
Vue.config.productionTip = true

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')